export const environment = {
  production: true,
  apiUrl: "/api/api/",
  backendBaseUrl: "https://en.eurodent.staging2.greendev.hu",
  galleryLength: 27,
  ipApiUrl: "https://api.ipify.org/?format=json"
};
